import { render, staticRenderFns } from "./courseModel.vue?vue&type=template&id=6914fd12"
import script from "./courseModel.vue?vue&type=script&lang=js"
export * from "./courseModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports